import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import {
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { BodyCompositionButton } from './bodycomposition-button';
import {BodyscaleResultBoxAndText} from './bodyscale-assessment-result-box-and-text';
import { mappedBodyTypes } from './bodyscale-bodytype-selector';

interface IProps {
  composition: any;
  athleteMode: boolean;
  t: (key: string, options?: any) => string;
  showBodyGroups(): void;
  startScan(): void;
}

const BodyscaleAssessmentSummary: FunctionComponent<IProps> = ({
  t,
  composition,
  showBodyGroups,
  startScan,
  athleteMode,
}) => {
  return (
    <View style={styles.container}>
      <View style={{alignItems: 'center', marginBottom: defaultScale(30) }}>
        <Text style={Theme.textStyle.heading2}>{t('bodyTypeResult')}</Text>
        <BodyscaleResultBoxAndText
          boxContent={
            <>
              {composition && mappedBodyTypes[composition].image(Theme.BLACK)}
              {composition && (
              <Text style={{ marginTop: defaultScale(9) }}>
                {mappedBodyTypes[composition].title}
              </Text>
              )}
            </>
          }
          textContent={composition ? t(`${composition}_Explainer`) : ''}
        />
      </View>
      <View style={styles.horizontalDivider}/>
      <View style={{alignItems: 'center'}}>
        <Text style={Theme.textStyle.heading2}>
          {t('bodyConditioningResult')}
        </Text>
        <BodyscaleResultBoxAndText
          boxContent={<Text>{athleteMode ? t('athlete') : t('standard')}</Text>}
          textContent={athleteMode ? t('isConditionedAthlete') : t('isNotConditionedAthlete')}
        />
      </View>
      <View style={styles.footer}>
        <BodyCompositionButton
          showBodyGroups={showBodyGroups}
          containerStyle={{paddingBottom: defaultScale(20)}}
        />
        <Button
          title={t('continueToScan')}
          onPress={() => startScan()}
          fontColor={Theme.WHITE}
          buttonType={ButtonTypes.NORMAL}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  footer: {
    marginTop: defaultScale(20),
    justifyContent: 'flex-end',
    flex: 1,
  },
  title: {
    ...Theme.textStyle.heading,
    color: Theme.BLACK,
    marginBottom: defaultScale(10),
  },
  resultBox: {
    width: defaultScale(125),
    height: defaultScale(108),
    borderWidth: defaultScale(1),
    borderColor: Theme.GREY_FIGMA_LIGHT,
    marginVertical: defaultScale(17),
    justifyContent: 'center',
    alignItems: 'center',
  },
  descriptionText: {
    ...Theme.textStyle.small,
    textAlign: 'center',
  },
  horizontalDivider: {
    width: '100%',
    height: defaultScale(0.5),
    backgroundColor: Theme.GREY_FIGMA_LIGHT,
    bottom: defaultScale(15),
  },
});

export default translate(['bodyscan'])(BodyscaleAssessmentSummary);
